
export const SubmitButtonHelper = ( { mustShowHelper, action = 'Submit' } ) => {
	return (mustShowHelper) ? <small id="submitHelp" className="form-text text-muted" style={{opacity: 0.4}}>{action} is disabled until valid data is entered in the form</small> : null;
};
 